export default __webpack_public_path__ + "static/IAMProxyIngestRole-1cbe99ff738c5c58e01140c60a99b62e.png";